import React from 'react';
import { connect } from 'react-redux';
import { ReactivityLevel } from '../user/ReactivityLevel';
var ReactivityLevelHome = function (_a) {
    var user = _a.user;
    return (user === null || user === void 0 ? void 0 : user.has('reactivity_level')) ? (React.createElement(ReactivityLevel, { reactivityLevel: user.get('reactivity_level'), displayLongLabel: true, textSize: "sm" })) : null;
};
var mapStateToProps = function (state, ownProps) { return ({
    user: state.loadedUsers[ownProps.userId]
}); };
export default connect(mapStateToProps)(ReactivityLevelHome);
